<template>
  <base-container>
    <el-descriptions
      :labelStyle="{ width: '50px', textAlign: 'center' }"
      :column="1"
      border
    >
      <el-descriptions-item label="总">
        <div class="color-success">
          <b>{{ idle.idleCount }}</b>
          <i class="margin-h5 el-icon-plus"></i>
          <el-input-number
            size="mini"
            :controls="false"
            style="width: 70px"
            :min="-100"
            :max="100"
            v-model="idleCount"
          ></el-input-number>
          <span class="margin-h5">=</span>
          <b class="margin-h5">{{ idleResult }}</b>
          <div v-show="idleWarnMsg" class="color-danger">
            ({{ idleWarnMsg }})
          </div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="男">
        <div class="color-primary">
          <b>{{ idle.manCount }}</b>
          <i class="margin-h5 el-icon-plus"></i>
          <el-input-number
            size="mini"
            :controls="false"
            style="width: 70px"
            :min="-100"
            :max="100"
            v-model="manCount"
          ></el-input-number>
          <span class="margin-h5">=</span>
          <b class="margin-h5">{{ manResult }}</b>
          <div v-show="manWarnMsg" class="color-danger">({{ manWarnMsg }})</div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="女">
        <div class="color-danger">
          <b>{{ idle.womenCount }}</b>
          <i class="margin-h5 el-icon-plus"></i>
          <el-input-number
            size="mini"
            :controls="false"
            style="width: 70px"
            :min="-100"
            :max="100"
            v-model="womenCount"
          ></el-input-number>
          <span class="margin-h5">=</span>
          <b class="margin-h5">{{ womenResult }}</b>
          <div v-show="womenWarnMsg" class="color-danger">
            ({{ womenWarnMsg }})
          </div>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <div style="margin: 5px 0; text-align: center">
      <el-button
        :loading="loading"
        type="primary"
        size="mini"
        icon="el-icon-check"
        @click="saveIdle"
      >
        确认
      </el-button>
    </div>
  </base-container>
</template>

<script>
import { saveWardIdle } from "@/api/bed/idle";
export default {
  props: {
    date: String,
    idle: {
      type: Object,
      defalut: () => {
        return {
          idleCount: 0,
          manCount: 0,
          womenCount: 0,
        };
      },
    },
  },
  data() {
    return {
      loading: false,
      idleCount: 0,
      manCount: 0,
      womenCount: 0,
    };
  },
  computed: {
    idleResult() {
      return this.idle.idleCount + this.idleCount;
    },
    manResult() {
      return this.idle.manCount + this.manCount;
    },
    womenResult() {
      return this.idle.womenCount + this.womenCount;
    },

    idleWarnMsg() {
      if (this.idleResult < 0) {
        return "空床数(总)不可为负数！";
      }
      if (this.idleResult < this.idle.useCount) {
        return "总空床数(总)不可小于已预约床位数！";
      }
      if (this.idleResult < this.manResult + this.womenResult) {
        return "总空床数(总)不可小于男女空床数之合！";
      }
      return "";
    },
    manWarnMsg() {
      if (this.manResult < 0) {
        return "空床数(男)不可为负数！";
      }
      if (this.idleResult < this.manResult + this.womenResult) {
        return "空床数(男+女)不可大于总空床数！";
      }
      return "";
    },
    womenWarnMsg() {
      if (this.womenResult < 0) {
        return "空床数(女)不可为负数！";
      }
      if (this.idleResult < this.manResult + this.womenResult) {
        return "空床数(男+女)不可大于总空床数！";
      }
      return "";
    },
  },
  methods: {
    saveIdle() {
      if (!(this.idleWarnMsg || this.manWarnMsg || this.womenWarnMsg)) {
        this.loading = true;
        let data = {
          wardIdleId: this.idle.wardIdleId,
          wardId: this.idle.wardId,
          doctorId: this.idle.id,
          idleDate: this.date,
          idleCount: this.idleCount,
          manCount: this.manCount,
          womenCount: this.womenCount,
        };
        saveWardIdle(data)
          .then(() => {
            this.$message({
              type: "success",
              message: "操作成功！",
            });
            this.idle.idleCount += this.idleCount;
            this.idle.manCount += this.manCount;
            this.idle.womenCount += this.womenCount;
            this.loading = false;
            this.idleCount = 0;
            this.manCount = 0;
            this.womenCount = 0;
            this.$emit("saved", this.idleCount, this.manCount, this.womenCount);
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style scoped></style>
